/* eslint-disable react/jsx-no-bind */
import {
  Button,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Container,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';

const CustomerList = () => {
  // Initial sample data
  const [rows, setRows] = useState([
    {
      id: 210,
      name: 'Mohammed Behashty',
      email: 'be************@.com',
      contact: '******3503',
      walletBalance: 0,
      status: true,
      appVersion: 0,
    },
    {
      id: 209,
      name: 'Test',
      email: 'cu******@.com',
      contact: '****9055',
      walletBalance: 0,
      status: true,
      appVersion: 0,
    },
    {
      id: 208,
      name: 'Elestinah',
      email: 'el**********@.com',
      contact: '******7898',
      walletBalance: 3,
      status: true,
      appVersion: 0,
    },
    {
      id: 207,
      name: 'Mansi Sapara',
      email: 'vl*************@.com',
      contact: '******3503',
      walletBalance: 50,
      status: false,
      appVersion: 0,
    },
  ]);

  const [editRow, setEditRow] = useState(null); // State for the row being edited
  const [openEditDialog, setOpenEditDialog] = useState(false); // State for edit dialog visibility
  const [openAddDialog, setOpenAddDialog] = useState(false); // State for add customer dialog
  const [newCustomer, setNewCustomer] = useState({
    id: '',
    name: '',
    email: '',
    contact: '',
    walletBalance: 0,
    status: true,
    appVersion: 0,
  }); // State for new customer data

  // Handle delete functionality
  const handleDelete = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  // Handle opening the edit dialog
  const handleEdit = (row) => {
    setEditRow(row);
    setOpenEditDialog(true);
  };

  // Handle saving the edit
  const handleSaveEdit = () => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === editRow.id ? editRow : row)),
    );
    setOpenEditDialog(false);
  };

  // Handle adding a new customer
  const handleAddCustomer = () => {
    setRows((prevRows) => [
      ...prevRows,
      { ...newCustomer, id: rows.length + 1 }, // Assign a unique ID
    ]);
    setOpenAddDialog(false);
    setNewCustomer({
      id: '',
      name: '',
      email: '',
      contact: '',
      walletBalance: 0,
      status: true,
      appVersion: 0,
    });
  };

  // Columns configuration for DataGrid
  const columns = [
    { field: 'id', headerName: 'No', width: 70 },
    { field: 'name', headerName: 'Customer Name', width: 200 },
    { field: 'email', headerName: 'Email', width: 180 },
    { field: 'contact', headerName: 'Contact No.', width: 150 },
    { field: 'walletBalance', headerName: 'Wallet Balance', width: 150 },
    {
      field: 'status',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (
        <Switch
          checked={params.row.status}
          onChange={() =>
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.row.id ? { ...row, status: !row.status } : row,
              ),
            )
          }
          color="primary"
        />
      ),
    },
    { field: 'appVersion', headerName: 'App Version', width: 120 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleEdit(params.row)}
            style={{ marginRight: '5px' }}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Container style={{ marginTop: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Customer List
      </Typography>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: '20px' }}
        onClick={() => setOpenAddDialog(true)}
      >
        Add Customer
      </Button>
      <div style={{ height: 500, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          checkboxSelection
        />
      </div>

      {/* Edit Dialog */}
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>Edit Customer</DialogTitle>
        <DialogContent>
          <TextField
            label="Customer Name"
            fullWidth
            margin="normal"
            value={editRow?.name || ''}
            onChange={(e) => setEditRow({ ...editRow, name: e.target.value })}
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={editRow?.email || ''}
            onChange={(e) => setEditRow({ ...editRow, email: e.target.value })}
          />
          <TextField
            label="Contact No."
            fullWidth
            margin="normal"
            value={editRow?.contact || ''}
            onChange={(e) =>
              setEditRow({ ...editRow, contact: e.target.value })
            }
          />
          <TextField
            label="Wallet Balance"
            type="number"
            fullWidth
            margin="normal"
            value={editRow?.walletBalance || ''}
            onChange={(e) =>
              setEditRow({ ...editRow, walletBalance: Number(e.target.value) })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Customer Dialog */}
      <Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)}>
        <DialogTitle>Add Customer</DialogTitle>
        <DialogContent>
          <TextField
            label="Customer Name"
            fullWidth
            margin="normal"
            value={newCustomer.name}
            onChange={(e) =>
              setNewCustomer({ ...newCustomer, name: e.target.value })
            }
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={newCustomer.email}
            onChange={(e) =>
              setNewCustomer({ ...newCustomer, email: e.target.value })
            }
          />
          <TextField
            label="Contact No."
            fullWidth
            margin="normal"
            value={newCustomer.contact}
            onChange={(e) =>
              setNewCustomer({ ...newCustomer, contact: e.target.value })
            }
          />
          <TextField
            label="Wallet Balance"
            type="number"
            fullWidth
            margin="normal"
            value={newCustomer.walletBalance}
            onChange={(e) =>
              setNewCustomer({
                ...newCustomer,
                walletBalance: Number(e.target.value),
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddCustomer} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CustomerList;
